import * as React from 'react'
import { Box, Typography as MIUTypography, Button, Divider } from '@mui/material'
import { codeQrBase } from '../../config/codeQrConfig'
import { styled } from '@mui/material/styles'
import { useTheme } from '@mui/material/styles'
import QRCodeStyling from 'qr-code-styling'

const Typography = styled(MIUTypography)(props => ({
  fontFamily: props.theme.typography.fontFamily,
  zIndex: 0,
  fontStyle: 'normal',
  fontSize: '0.95em',
  fontWeight: 500,
  lineHeight: '24px',
  color: '#000000ab',
  '&:hover': { color: 'var(--color-green-light)', fontWeight: 650 },
}))

const ContainerCode = styled('div')(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontStyle: 'normal',
  fontWeight: 600,
  fontSize: '13px',
  color: theme.palette.text.primary,
  paddingBottom: 4,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}))

const CodeQrModal = ({ onClose, treeId, data, isAuth }) => {
  const theme = useTheme()

  const codeQrContainer = React.useRef(null)
  const [fileExt, setFileExt] = React.useState('png')
  const background = fileExt === 'png' ? '#ffffff00' : '#ffffff'
  const colorPopupValue = theme.palette.text.primary
  const qrCode = React.useMemo(
    () => new QRCodeStyling(codeQrBase({ data, background })),
    [background, data],
  )

  const handleDownloadAction = () => qrCode.download({ name: treeId, extension: fileExt })
  const onExtensionChange = event => setFileExt(event.target.value)

  React.useEffect(() => {
    if (!codeQrContainer.current) return
    codeQrContainer.current.innerHTML = ''
    qrCode.append(codeQrContainer.current)
  }, [qrCode])

  return (
    <Box>
      <Box sx={{ width: '100%', height: '100%', p: 0, m: 0 }} ref={codeQrContainer} />
      <ContainerCode
        sx={{
          textAlign: 'start',
          fontSize: '14px',
          fontWeight: 500,
        }}>
        Código: {` `}
        <span
          style={{
            color: colorPopupValue,
            fontSize: '14px',
            fontWeight: 700,
            borderRadius: 10,
            paddingInline: 16,
            // paddingBlock: 2,
            border: '2px solid rgba(0, 0, 0, 0.04)',
            backgroundColor: '#84a93e16',
          }}>
          {treeId}
        </span>
      </ContainerCode>
      <Divider sx={{ bgcolor: 'primary.main' }} />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-evenly',
          alignItems: 'baseline',
        }}>
        {Boolean(isAuth) && (
          <Box>
            <select onChange={onExtensionChange} value={fileExt}>
              <option value="png">PNG</option>
              <option value="jpeg">JPEG</option>
              <option value="webp">WEBP</option>
            </select>
          </Box>
        )}
        <Button onClick={onClose}>
          <Typography sx={{ '&:hover': { color: 'primary.main' } }}>Regresar</Typography>
        </Button>
        {Boolean(isAuth) && (
          <Button onClick={handleDownloadAction}>
            <Typography>Descargar</Typography>
          </Button>
        )}
      </Box>
    </Box>
  )
}
export default React.memo(CodeQrModal)
